<h4 mat-dialog-title><i class="fas fa-pen mr-1"></i> Reset Password</h4>

<mat-dialog-content class="mat-typography">
    <form class="example-form input-content" [formGroup]="form">

        <mat-form-field class="example-full-width">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" aria-label="First Name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" aria-label="Last Name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="emailAddress" type="email" autocomplete="on" aria-label="Email">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>New Password*</mat-label>
            <input matInput type="password" formControlName="password" aria-label="New Password">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Confirm Password*</mat-label>
            <input matInput type="password" formControlName="confirmPassword" aria-label="Confirm Password">
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-warning float-right mr-2" aria-label="update" type="submit" [disabled]="!form.valid" (click)="resetPassword()">
        <i class="fas fa-pen mr-1"></i> Update</button>
    <button class="btn btn-light float-right" aria-label="cancle" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel</button>
</mat-dialog-actions>
